import React from 'react';
const Menu = () => {
    return (
        <div>
            <h1>Hello!</h1>
        </div>
    );
}

export default Menu;